import { lighten } from 'polished';
import styled, { css } from 'styled-components';

export const HeaderWithOutUser = styled.header`
  ${({ theme: { colors, breakpoints } }) => css`
    width: 100%;
    background-color: ${lighten(0.9, colors.white)};
    z-index: 2;

    > div {
      max-width: ${breakpoints.xl};
      min-height: 60px;
      margin: 0 auto;
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media screen and (max-width: 1570px) {
        margin: 0 64px;
      }

      @media screen and (max-width: ${breakpoints.md}) {
        margin: 0 32px;
      }

      @media screen and (max-width: ${breakpoints.sm}) {
        margin: 0 16px;
      }
    }
  `}
`;

export const LogoExtended = styled.img`
  ${({ theme: { breakpoints } }) => css`
    @media (max-width: ${breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const LogoCompressed = styled.img`
  ${({ theme: { breakpoints } }) => css`
    @media (min-width: calc(${breakpoints.sm} + 1px)) {
      display: none;
    }
  `}
`;
